import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const Content = styled.div`
  margin-top: 8px;
  padding: 0 16px;
  font-size: 11px;
  line-height: 16px;
  color: #d00a00;
`

const WithErrorMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ErrorMessage = props => {
  const { children, renderIfEmpty, ...rest } = props

  if (!children && !renderIfEmpty) return null

  return <Content {...rest}>{children}</Content>
}

export const WithErrorMessage = ({ children, error, ...rest }) => {
  const { t } = useTranslation()

  return (
    <WithErrorMessageWrapper {...rest}>
      {children}
      {error && <Content>{t(error)}</Content>}
    </WithErrorMessageWrapper>
  )
}

export default ErrorMessage
